import {FaJava,FaReact,FaPython,} from "react-icons/fa";
import {SiUikit}  from 'react-icons/si';
// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <FaReact />,
    title: "Full Stack Development",
    des: "Experienced in MERN and React-native basics, I've completed some full-stack projects during my education, showcasing proficiency in both front-end and back-end development.",
  },
  {
    id: 2,
    icon: <FaJava />,
    title: "Java",
    des: "Passionate about Java and Object-Oriented Programming (OOP), I have practical experience working on Java by developing consolebased applications.",
  },
  {
    id: 3,

    title: "Data Structures",
    des: "I consistently practice Data Structures and Algorithms (DSA) and have solved over 400+ problems on platforms like LeetCode,CodeStudio,GeeksForGeeks enhancing my problem-solving skills.",
  },
  
  
];
